module.exports = __webpack_public_path__ + "img/bg1.d53ee9f0.png";